export default __webpack_public_path__ + "static/media/Pin_Job_Tow_Large.17926f75.svg";